import { useState } from "react";
import { Plus } from "lucide-react";
import { ShelfRow } from "@/components/library/ShelfRow";

const NewShelf = ({ onCreate, disabled }) => {
  const [name, setName] = useState("");
  const submit = (e) => { e.preventDefault(); if (!name.trim()) return; onCreate(name.trim()); setName(""); };
  return (
    <form onSubmit={submit} className="flex items-center gap-2" data-testid="new-shelf-form">
      <input value={name} onChange={(e) => setName(e.target.value)} maxLength={60} placeholder="New shelf, e.g. Textbooks" disabled={disabled} className="neu-inset w-56 rounded-full px-4 py-2 text-sm placeholder:text-[#94A3B8] focus:outline-none disabled:opacity-60" data-testid="new-shelf-input" />
      <button disabled={disabled || !name.trim()} className="neu-btn flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold text-[#3D3DF0] disabled:opacity-50" data-testid="new-shelf-btn"><Plus className="h-4 w-4" />Add shelf</button>
    </form>
  );
};

export const Bookshelf = ({ books, shelves, canEdit, onMove, onDeleteBook, onCreate, onRename, onDelete }) => {
  const known = new Set(shelves.map((s) => s.shelf_id));
  const unsorted = books.filter((b) => !b.shelf_id || !known.has(b.shelf_id));
  return (
    <div data-testid="bookshelf">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <p className="text-sm text-[#64748B]">Drag a book onto any shelf, or use its <b>⋯</b> menu → Move to shelf.</p>
        <NewShelf onCreate={onCreate} disabled={!canEdit} />
      </div>
      <div className="mt-10 space-y-12">
        {shelves.map((s) => (
          <ShelfRow key={s.shelf_id} shelf={s} books={books.filter((b) => b.shelf_id === s.shelf_id)} shelves={shelves} onMove={onMove} onDeleteBook={onDeleteBook} onRename={onRename} onDelete={onDelete} />
        ))}
        {(unsorted.length > 0 || shelves.length === 0) && (
          <ShelfRow shelf={{ shelf_id: "", name: shelves.length ? "Unsorted" : "My shelf" }} books={unsorted} shelves={shelves} onMove={onMove} onDeleteBook={onDeleteBook} />
        )}
      </div>
    </div>
  );
};
